module.exports = __webpack_public_path__ + "static/media/favicon-eappsoft.97659a2e.png";